module.exports = __webpack_public_path__ + "static/media/loading.afa9bc31.svg";